import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { API_BASE_URL } from '../../config';
import './Auth.css';
import logo from '../../assets/Logo - Side.png';

function VerifyPending() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [resending, setResending] = useState(false);
  const [resendSuccess, setResendSuccess] = useState(false);
  const [countdown, setCountdown] = useState(0);

  useEffect(() => {
    const pending = localStorage.getItem('pendingVerification');
    if (pending) {
      const data = JSON.parse(pending);
      setEmail(data.email);
    } else {
      navigate('/signup');
    }
  }, [navigate]);

  useEffect(() => {
    if (countdown > 0) {
      const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
      return () => clearTimeout(timer);
    }
  }, [countdown]);

  const handleResend = async () => {
    if (countdown > 0) return;
    
    setResending(true);
    setResendSuccess(false);

    try {
      const res = await fetch(`${API_BASE_URL}/api/saas/resend-verification`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      });

      if (res.ok) {
        setResendSuccess(true);
        setCountdown(60);
      }
    } catch (error) {
      console.error('Error resending verification:', error);
    } finally {
      setResending(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="verify-pending">
          <Link to="/">
            <img src={logo} alt="RentafAI" className="auth-logo" />
          </Link>
          
          <div className="verify-icon">📧</div>
          
          <h1>Check Your Email</h1>
          
          <p>
            We've sent a verification link to<br />
            <span className="email-highlight">{email}</span>
          </p>
          
          <p>
            Click the link in the email to verify your account and complete setup.
            The link expires in 24 hours.
          </p>

          {resendSuccess && (
            <div className="auth-success">
              Verification email sent! Check your inbox.
            </div>
          )}

          <div className="verify-actions">
            <button 
              className="resend-link"
              onClick={handleResend}
              disabled={resending || countdown > 0}
            >
              {resending 
                ? 'Sending...' 
                : countdown > 0 
                  ? `Resend in ${countdown}s` 
                  : "Didn't receive the email? Resend"}
            </button>
          </div>

          <div className="auth-footer">
            <p>
              Wrong email? <Link to="/signup">Start over</Link>
            </p>
            <p>
              Already verified? <Link to="/">Log in</Link>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default VerifyPending;
